import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

  static values = {
    open: Boolean,
  };

  connect() {
    useClickOutside(this, { element: this.element })
  }

  toggle(e) {
    this.openValue = !this.openValue;
    e.currentTarget.setAttribute('aria-expanded', this.openValue);
  }

  close() {
    this.openValue = false;
  }

  clickOutside() {
    this.close();
  }
}